<template>
	<div class="col-12 text-left">
		<div v-for="(sellableProgram, index) in sellablePrograms" class="custom-control custom-radio mb-2">
			<input
				:id="`event-form-item-${sellableProgram.id}`"
				:checked="product.id === sellableProgram.id"
				name="customRadio"
				type="radio"
				class="custom-control-input"
				@change="setProduct(index, sellableProgram.crm_landing_id)"
			>
			<label
				class="custom-control-label"
				:for="`event-form-item-${sellableProgram.id}`"
			>
				{{ sellableProgram.title }}
			</label>
		</div>
	</div>
</template>

<script>
import {
	ACTION_GET_PRICE_DATA,
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA,
	MUTATION_SET_LOCAL_META_DATA,
} from '@/store/checkout';

export default {
	name: 'ProductSelector',
	props: {
		sellablePrograms: {
			type: Array,
			default: null,
		},
		product: {
			type: Object,
			default: null,
		},
		formData: {
			type: Object,
			default: null,
		},
	},
	methods: {
		async setProduct(index, item) {
			await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_LOCAL_META_DATA}`, {
				formId: this.formData.id,
				select_landing_id: item,
				localMeta: {
					product: this.sellablePrograms[index],
				},
			});

			await this.$store.commit(`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`, {
				formId: this.formData.id,
				select_landing_id: item,
				meta: {
					productId: this.sellablePrograms[index].id,
				},
			});

			await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`, {
				formId: this.formData.id,
				select_landing_id: item,
			});

			await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_PRICE_DATA}`, { formId: this.formData.id, select_landing_id: item });
		},
	},
};
</script>

<style scoped>

</style>
